export default __webpack_public_path__ + "static/media/(24).4f1bad85.jpg";